import React, { useState, useRef } from "react";
import "./PortfolioSection.css";

// Import your before & after comparison images here
import skinRejuvenationImg from "../assets/Port1.jpg";
import scarTreatmentImg from "../assets/Port2.jpg";
import permanentMakeupImg from "../assets/Port3.png";
import pigmentationTherapyImg from "../assets/P1.jpg";

const portfolioItems = [
  { id: 1, title: "Skin Rejuvenation", image: skinRejuvenationImg },
  { id: 2, title: "Scar Treatment", image: scarTreatmentImg },
  { id: 3, title: "Permanent Makeup", image: permanentMakeupImg },
  { id: 4, title: "Pigmentation Therapy", image: pigmentationTherapyImg },
];

function PortfolioSection() {
  const scrollRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 320, behavior: "smooth" });
    }
  };

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -320, behavior: "smooth" });
    }
  };

  return (
    <section className="portfolio-section">
      {/* Header */}
      <div className="portfolio-header">
        <span className="badge-title">REAL RESULTS</span>
        <h2 className="section-title">Portfolio</h2>
      </div>

      {/* Horizontal Rolling Carousel Container */}
      <div className="carousel-wrapper">
        <button className="scroll-btn left-btn" onClick={scrollLeft} aria-label="Scroll left">
          ‹
        </button>

        <div className="portfolio-row" ref={scrollRef}>
          {portfolioItems.map((item) => (
            <div
              key={item.id}
              className="portfolio-card"
              onClick={() => setSelectedImage(item.image)}
            >
              <img src={item.image} alt={item.title} />
            </div>
          ))}
        </div>

        <button className="scroll-btn right-btn" onClick={scrollRight} aria-label="Scroll right">
          ›
        </button>
      </div>

      {/* Full Screen Lightbox Modal */}
      {selectedImage && (
        <div className="portfolio-modal" onClick={() => setSelectedImage(null)}>
          <button
            className="modal-close-btn"
            onClick={() => setSelectedImage(null)}
            aria-label="Close"
          >
            ✕
          </button>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage} alt="Before & After Full View" />
          </div>
        </div>
      )}
    </section>
  );
}

export default PortfolioSection;